import { z } from "zod"

export const answerSheetSchema = z.object({
  id: z.number(),
  is_first_time: z.coerce.boolean(),
  score: z.number().nullable(),
  updated_at: z.coerce.date(),
})

export type AnswerSheet = z.infer<typeof answerSheetSchema>